import {
  NACA_CARD_BODY,
  NACA_CARD_HEADLINE,
  NACA_CARD_POINTS,
  NACA_COMPARE,
  NACA_DESCRIPTION,
  NACA_DISCLOSURE,
  NACA_DOES_NOT_FIT,
  NACA_FAQS,
  NACA_FITS,
  NACA_PATH,
  NACA_STEPS,
  NACA_TITLE,
  NACA_WORKSHOP_URL,
} from "@/data/nacaPartnerData";
import type { Partner } from "./types";

/**
 * NACA as a registry entry. Copy is re-used verbatim from the original NACA
 * data module so the existing /partners/naca page and card are unchanged.
 */
export const naca: Partner = {
  slug: "naca",
  name: "NACA",
  fullName: "Neighborhood Assistance Corporation of America",
  path: NACA_PATH,
  externalUrl: NACA_WORKSHOP_URL,
  externalLabel: "Attend a NACA workshop",

  title: NACA_TITLE,
  description: NACA_DESCRIPTION,
  h1: "NACA: the no-down-payment, no-PMI path — and what it actually costs you",

  cardHeadline: NACA_CARD_HEADLINE,
  cardBody: NACA_CARD_BODY,
  cardPoints: NACA_CARD_POINTS,

  barriers: ["savings", "credit"],
  hubSummary:
    "A nonprofit with its own mortgage: no down payment, no closing costs, no PMI, no credit-score minimum — in exchange for a long, counseling-heavy process.",

  fits: NACA_FITS,
  doesNotFit: NACA_DOES_NOT_FIT,
  steps: NACA_STEPS,
  compareLabel: "NACA",
  compare: NACA_COMPARE.map((r) => ({ factor: r.factor, partner: r.naca, stack: r.stack })),
  faqs: NACA_FAQS,
  disclosure: NACA_DISCLOSURE,
};
